import React, { useContext, useEffect, useRef, useState } from "react";
import CloseIcon from "@mui/icons-material/Close"; //newly added
import IconButton from "@mui/material/IconButton"; //newly added
import StarIcon from "@mui/icons-material/Star"; //newly added
import StarOutlineIcon from "@mui/icons-material/StarOutline"; //newly added
import NoDataDisplay from "../../assests/img/NoDataDisplay.jsx";
import Daily_usage from "../../assests/img/dashboardIcons/Daily_usage.png";
import Data_connectivity from "../../assests/img/dashboardIcons/Data_connectivity.png";
import System_Uptime from "../../assests/img/dashboardIcons/System_Uptime.png";
import Resources from "../../assests/img/dashboardIcons/Resources.png";
import Reliability_score from "../../assests/img/dashboardIcons/Reliability_score.png";
import HaqtDateRangePicker from "../../components/HaqtDateRangePicker/HaqtDateRangePicker.js";
import WOSH from "../../assests/img/dashboardIcons/WOTA.png";
import {
  getSessionStorageItem,
  setSessionStorageItem,
} from "../../utils/sessionStorageUtils"; // added for wosh
//import AccessTimeIcon from '@mui/icons-material/AccessTime'; //added for wosh
import { FormControl, Select, MenuItem, Tabs, Tab } from "@mui/material";
import {
  getDropdownOptions,
  getMapFiltersData,
  getMapListData,
  getPositions,
  getRefinedListData,
  getSitesForTenant,
  statusData,
} from "./MapUtils";
import {
  Card,
  CardContent,
  CardHeader,
  Grid,
  useMediaQuery,
} from "@mui/material";
import HaqtSingleSelect from "../../components/HaqtSingleSelect/HaqtSingleSelect";
import HaqtMap from "../../components/HaqtMap/HaqtMap";
import { AppContext } from "../../context/AppContextProvider";
import SiteHeader from "./SiteHeader";
import "./MapView.scss";
import {
  ALERT_LEVEL,
  DEVICE_HEALTH_GOOD,
  DROPDOWN_WIDTH,
  LOADING_TEXT,
  SYSTEM_NOT_AVAILABLE,
} from "./MapConstants";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Popover from "@mui/material/Popover";
import { CardActionArea } from "@mui/material";
import {
  getDashboardDetails,
  getChartData,
  getImageData,
} from "../../services/DashboardServices";

import { getErrorcodes } from "../../services/MaintenanceServices";

import {
  getDashboardPanelCards,
  getDashboardPanelCharts,
} from "../../services/TenantServices";
import DashboardDetails from "../../pages/Dashboard/DashboardDetails";
import HaqtChart from "../../components/HaqtCharts/HaqtChart";
import { addDays } from "date-fns";
import { timestampToDateTime } from "../../utils/TimeStampToDateTime.js";
import { truncateDecimals } from "../../utils/TruncateDecimals.js";
import { LinearProgress } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import VerifiedIcon from "@mui/icons-material/Verified";
import WaterDropIcon from "@mui/icons-material/WaterDrop";
import { Title } from "@mui/icons-material";
import WoshDateRangePicker from "../../components/WoshDateRangePicker/WOSHDateRangePicker.js";
import MapSearch from "./Components/MapSearch.js";
// import InfoWindowContent from "./InfoWindow";

const MapView = () => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const [filterData, setFilterData] = useState([]); //in filterData we will get all dropdowpdown- data for maps.
  const [listData, setListData] = useState([]); // in this list data we will get all the Device and alerts data.
  const [filteredListData, setFilteredListData] = useState([]);
  const [positions, setPositions] = useState([]); //positions having data that we need to show on the map.
  const [countriesData, setCountriesData] = useState([]);
  const [tenantData, setTenantData] = useState([]);
  const [siteData, setSiteData] = useState([]);
  // const [selectedMarker, setSelectedMarker] = useState("");
  // const [hoveredMarker, setHoveredMarker] = useState(null); // Dheeraj Edit - removed
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedTenant, setSelectedTenant] = useState("");
  const [selectedSite, setSelectedSite] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const gridRef = useRef();
  const [sizeForDropdown, setSizeForDropDown] = useState(0);
  const [noMsgText, setNoMsgText] = useState("");
  const { showSpinner, setShowSpinner } = useContext(AppContext);
  const [showDateRangePicker, setShowDateRangePicker] = useState(false); // Dheeraj Edit
  const [selectedCard, setSelectedCard] = useState(null);
  const [selectedTile, setSelectedTile] = useState(null);
  const [cardCount, setCardCount] = useState(4);
  const [cardAnchorEl, setCardAnchorEl] = React.useState(null);
  const [showPopup, setShowPopUp] = useState(false);
  const [dashboardData, setDashboardData] = useState({});
  const [deviceName, setDeviceName] = useState(""); // newly added for WOSH
  const [deviceId, setDeviceId] = useState({}); // newly added for WOSH
  const [selectedHours, setSelectedHours] = useState(24); // Initialize with 24 newly added for WOSH
  const [dragging, setDragging] = useState(false); // newly added for WOSH
  const [width, setWidth] = useState(300);
  const [dashboardWidth, setDashboardWidth] = useState(460); // Intial width of 460px
  const [showDashboard, setShowDashboard] = useState(false); // newly added
  // Dheeraj Edit
  const [isCustomClicked, setIsCustomClicked] = useState(false);
  const [customDateRange, setCustomDateRange] = useState(null);
  const [mapSearchOptions, setMapSearchOptions] = useState({});
  const [selectedCenter, setSelectedCenter] = useState(null);
  //
  const isLargeScreen = useMediaQuery("(min-width:1200px)"); // For large monitors
  const isMediumScreen = useMediaQuery("(min-width:900px)"); // For medium screens (laptops)
  const isBiggerScreen = useMediaQuery("(min-width:1300px)"); // Dheeraj Edit
  const cardPopoverOpen = Boolean(cardAnchorEl);
  const getStarRating = (value) => {
    // Convert percentage (0-100) to 1-5 scale
    const numericValue = Number(value);
    const ratingValue = (numericValue / 100) * 5;
    const roundedRating = Math.round(ratingValue * 10) / 10; // Round to 1 decimal

    // Return stars based on the 1-5 rating
    if (roundedRating >= 4.5) return 5;
    if (roundedRating >= 3.5) return 4;
    if (roundedRating >= 2.5) return 3;
    if (roundedRating >= 1.5) return 2;
    return 1;
  };

  const closeDateRangePicker = () => {
    setShowDateRangePicker(false);
  };

  const StarRating = ({ rating, value }) => {
    // Convert percentage to 1-5 scale
    const ratingValue = (Number(value) / 100) * 5;
    const displayValue = ratingValue.toFixed(1);
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "4px",
        }}
      >
        <span
          style={{
            fontSize: "14px",
            fontWeight: "500",
            color: "#333333",
          }}
        >
          {displayValue}
        </span>
        <div style={{ display: "flex", gap: "2px" }}>
          {[1, 2, 3, 4, 5].map((star) => (
            <span key={star}>
              {star <= rating ? (
                <StarIcon
                  sx={{
                    color: "#FFD700",
                    fontSize: "16px",
                  }}
                />
              ) : (
                <StarOutlineIcon
                  sx={{
                    color: "#C0C0C0",
                    fontSize: "16px",
                  }}
                />
              )}
            </span>
          ))}
        </div>
        <span
          style={{
            fontSize: "14px",
            color: "#666666",
          }}
        ></span>
      </div>
    );
  };

  // const SettingMapSearch = (data) => {
  //   // Create a new object with all the search options
  //   const newSearchOptions = {
  //     tenant: [
  //       ...new Set(data.data.tenants.flatMap((tenant) => tenant.tenantName)),
  //     ],
  //     country: [
  //       ...new Set(
  //         data.data.tenants.flatMap((tenant) =>
  //           tenant.sites.map((site) => site.country),
  //         ),
  //       ),
  //     ],
  //     city: [
  //       ...new Set(
  //         data.data.tenants.flatMap((tenant) =>
  //           tenant.sites.map((site) => site.city),
  //         ),
  //       ),
  //     ],
  //     site: [
  //       ...new Set(
  //         data.data.tenants.flatMap((tenant) =>
  //           tenant.sites.map((site) => site.siteName),
  //         ),
  //       ),
  //     ],
  //     device: [
  //       ...new Set(
  //         data.data.tenants.flatMap((tenant) =>
  //           tenant.sites.flatMap((site) =>
  //             site.devices.flatMap((device) => device.deviceDescription),
  //           ),
  //         ),
  //       ),
  //     ],
  //   };

  //   // Update the state with the new options
  //   setMapSearchOptions(newSearchOptions);
  // };

  const SettingMapSearch = (data) => {
    // Create a new object with all the search options
    const newSearchOptions = {
      tenant: [
        ...new Set(
          data.data.tenants.map((tenant) => ({
            value: tenant.tenantName,
            coordinates: tenant.sites.map((site) => ({
              lat: site.latitude,
              lng: site.longitude,
            })),
          })),
        ),
      ],
      country: [
        ...new Set(
          data.data.tenants.flatMap((tenant) =>
            tenant.sites.map((site) => ({
              value: site.country,
              coordinates: [{ lat: site.latitude, lng: site.longitude }],
            })),
          ),
        ),
      ],
      city: [
        ...new Set(
          data.data.tenants.flatMap((tenant) =>
            tenant.sites.map((site) => ({
              value: site.city,
              coordinates: [{ lat: site.latitude, lng: site.longitude }],
            })),
          ),
        ),
      ],
      site: [
        ...new Set(
          data.data.tenants.flatMap((tenant) =>
            tenant.sites.map((site) => ({
              value: site.siteName,
              coordinates: [{ lat: site.latitude, lng: site.longitude }],
            })),
          ),
        ),
      ],
      device: [
        ...new Set(
          data.data.tenants.flatMap((tenant) =>
            tenant.sites.flatMap((site) =>
              site.devices.map((device) => ({
                value: device.deviceDescription,
                coordinates: [{ lat: site.latitude, lng: site.longitude }],
              })),
            ),
          ),
        ),
      ],
    };

    // Merge coordinates for duplicate values
    Object.keys(newSearchOptions).forEach((category) => {
      const merged = new Map();

      newSearchOptions[category].forEach((item) => {
        if (merged.has(item.value)) {
          merged.get(item.value).coordinates.push(...item.coordinates);
        } else {
          merged.set(item.value, {
            value: item.value,
            coordinates: [...item.coordinates],
          });
        }
      });

      newSearchOptions[category] = Array.from(merged.values());
    });

    // Update the state with the new options
    setMapSearchOptions(newSearchOptions);
  };

  const SetMapCenter = (item) => {
    setSelectedCenter(item);
  };

  const getCardHeight = () => {
    if (isLargeScreen) {
      return "300px"; // Larger height for big monitors
    } else if (isMediumScreen) {
      return "70px"; // Medium height for laptops
    } else {
      return "70px"; // Smaller height for smaller screens
    }
  };
  const getChartHeight = () => {
    if (isLargeScreen) {
      return 280; // Larger chart height for big monitors
    } else if (isMediumScreen) {
      return 150; // Medium chart height for laptops
    } else {
      return 180; // Small chart height for smaller screens
    }
  };
  const handleCardPopoverOpen = (card, event) => {
    setSelectedCard(card);
    setCardAnchorEl(event.currentTarget);
  };
  const handleCardPopoverClose = () => {
    setCardAnchorEl(null);
  };
  const [height, setHeight] = useState("50vh");
  const [activeTab, setActiveTab] = useState(0);
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  //Dheeraj Edit - Made Datetime formatting code into a seperate function

  const formatDateTime = (dateTime) => {
    const year = dateTime.getFullYear();
    const month = String(dateTime.getMonth() + 1).padStart(2, "0");
    const day = String(dateTime.getDate()).padStart(2, "0");
    const hours24 = String(dateTime.getHours()).padStart(2, "0");
    const minutes = String(dateTime.getMinutes()).padStart(2, "0");
    const seconds = String(dateTime.getSeconds()).padStart(2, "0");

    // Format: YYYY-MM-DD HH:mm:ss
    const formattedDatetime = `${year}-${month}-${day} ${hours24}:${minutes}:${seconds}`;

    return formattedDatetime;
  };

  // Dheeraj Edit - added

  const calculateButtonDates = (selectedHours) => {
    const toDate = new Date();
    const fromDate = new Date();
    fromDate.setHours(toDate.getHours() - selectedHours);

    const startDate = formatDateTime(fromDate);
    const endDate = formatDateTime(toDate);
    return [startDate, endDate];
  };

  const calculateCustomDates = () => {
    const startDate = formatDateTime(customDateRange[0].startDate);
    // const endDate = formatDateTime(customDateRange[0].endDate);
    const endDate = formatDateTime(addDays(customDateRange[0].endDate, 1));

    return [startDate, endDate];
  };

  const dateRangeHandler = (range) => {
    setCustomDateRange((prevRange) => {
      const updatedRange = range;
      return updatedRange;
    });
  };

  // Dheeraj Edit

  const dashboardApi = async (startDate, endDate) => {
    try {
      if (!deviceId || deviceId === "") {
        console.log("Device ID is invalid. API call will not be made.");
        return null; // Early return if deviceId is invalid
      }
      const response = await getDashboardPanelCards(
        deviceId,
        startDate,
        endDate,
      );
      return response && response.data ? response.data : null;
    } catch (error) {
      console.log("error in panel - cards API", error);
      return null;
    }
  };

  const chartApi = async (startDate, endDate) => {
    try {
      if (!deviceId || deviceId === "") {
        console.log("Device ID is invalid. API call will not be made.");
        return null; // Early return if deviceId is invalid
      }
      const response = await getDashboardPanelCharts(
        deviceId,
        startDate,
        endDate,
        0.02,
        105,
        80,
      );
      return response && response.data ? response.data : null;
    } catch (error) {
      console.log("error in panel - chart API", error);
      return null;
    }
  };

  const loadDashboardData = async () => {
    try {
      setShowSpinner(true);
      // const [startDate, endDate] = calculateButtonDates(selectedHours); // Dheeraj Edit
      const [startDate, endDate] = isCustomClicked
        ? calculateCustomDates()
        : calculateButtonDates(selectedHours);
      const dashboardDetails = dashboardApi(startDate, endDate);
      const chartDetails = chartApi(startDate, endDate);
      const [dashboardResponse, chartResponse] = await Promise.all([
        dashboardDetails,
        chartDetails,
      ]);
      // below set as default for WOSH
      const status = "Active";

      // Process chart data if needed
      const processedChartData = chartResponse.map((chart) => ({
        ...chart,
        details: chart.details?.map((detail) => ({
          ...detail,
          value: parseFloat(detail.value) || 0,
        })),
      }));
      setDashboardData({ ...dashboardResponse, charts: processedChartData });
    } catch (e) {
      setShowSpinner(false);
      console.error("Error loading dashboard data:", e);
    } finally {
      setShowSpinner(false);
    }
  };

  const getIcon = (iconShape) => {
    switch (iconShape) {
      case "hand-sparkles":
        return <HandSanitizerIcon sx={{ color: "#6b7280" }} />;
      case "activity":
        return <AccessTimeIcon sx={{ color: "#6b7280" }} />;
      case "check-circle":
        return <VerifiedIcon sx={{ color: "#6b7280" }} />;
      case "droplet":
        return <WaterDropIcon sx={{ color: "#6b7280" }} />;
      default:
        return null;
    }
  };

  const colors = ["#36C8B4", "#148595", "#74E9B7", "#4CD1D1", "#AFF0A8"];

  const spacing = {
    5: {
      container: 10,
      item: {
        xs: 2,
        sm: 2,
        md: 2,
        lg: 2,
      },
    },
    4: {
      container: 12,
      item: {
        xs: 3,
        sm: 3,
        md: 3,
        lg: 3,
      },
    },
    3: {
      container: 12,
      item: {
        xs: 4,
        sm: 4,
        md: 4,
        lg: 4,
      },
    },
    2: {
      container: 12,
      item: {
        xs: 6,
        sm: 6,
        md: 6,
        lg: 6,
      },
    },
    1: {
      container: 12,
      item: {
        xs: 12,
        sm: 12,
        md: 12,
        lg: 12,
      },
    },
  };

  const onCardClick = () => {
    setSelectedTile(null);
    detailsCallBack();
  };

  const tooltipContent = (x, y, value) => {
    return `
                <Box className="tooltip-content">

                <Typography>Min: ${truncateDecimals(value.minValue)}</Typography><br/><br/>
                <Typography>Curr: ${truncateDecimals(y)}</Typography><br/><br/>
                <Typography>Max: ${truncateDecimals(value.maxValue)}</Typography></Box>
              `;
  };

  const detailsCallBack = () => {
    setShowPopUp((prev) => !prev);
  };
  const handleCancel = () => {
    setShowPopUp((prev) => !prev);
    setSelectedTile(null);
  };
  // Dheeraj Edit - removed

  // Hover handlers
  // const handleMarkerHover = (marker) => {
  //   setHoveredMarker(marker);
  // };

  // const handleMarkerLeave = () => {
  //   setHoveredMarker(null);
  // };

  // Dheeraj Edit

  const handleMarkerClick = (site, e) => {
    const newDeviceId = site.devices[0].deviceId;
    const newDeviceName = site.devices[0].deviceDescription;
    setDeviceName(newDeviceName);
    setDeviceId(newDeviceId);
    setShowDashboard(true);
  };

  const handleCloseDashboard = () => {
    setShowDashboard(false);
    setDashboardWidth(460); // (Dheeraj Edit) Reset width opening closing  , width change
  };
  const dashboardRef = useRef(null);

  const handleClickOutside = (event) => {
    const conditions = {
      isDashboardOpen: showDashboard,
      hasDashboardRef: !!dashboardRef.current,
      isClickOutsideDashboard: !dashboardRef.current?.contains(event.target),
      isClickInMapSection: !!event.target.closest(".map-section"),
      clickTarget: event.target,
      dashboardRefElement: dashboardRef.current,
    };

    // Check each condition individually
    if (showDashboard) {
      if (dashboardRef.current) {
        if (!dashboardRef.current.contains(event.target)) {
          if (event.target.closest(".map-section")) {
            setShowDashboard(false);
          } else {
            console.log("Failed: Click not in map section");
          }
        } else {
          console.log("Failed: Click is inside dashboard");
        }
      } else {
        console.log("Failed: No dashboard ref");
      }
    } else {
      console.log("Failed: Dashboard not open");
    }
  };

  useEffect(() => {
    if (deviceId !== null && deviceId !== "") {
      // Only load if there's a valid deviceId
      loadDashboardData();
    }
  }, [selectedHours, deviceId, customDateRange]);

  useEffect(() => {
    getMapData();
  }, []);

  useEffect(() => {
    const gridItemsLength = gridRef.current?.children.length || 0;
    if (gridItemsLength === 4) {
      setSizeForDropDown(3);
    } else if (gridItemsLength === 3) {
      setSizeForDropDown(4);
    } else if (gridItemsLength === 2) {
      setSizeForDropDown(6);
    }
    const handleMouseMove = (e) => {
      if (dragging) {
        e.preventDefault(); // Prevent text selection while dragging
        const newWidth = e.clientX;
        setDashboardWidth(Math.max(460, Math.min(850, newWidth))); // width change
      }
    };
    const handleMouseUp = () => {
      setDragging(false);
    };

    if (dragging) {
      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
    }

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, [
    countriesData,
    tenantData,
    siteData,
    statusData,
    isSmallScreen,
    dragging,
  ]);

  // Dheeraj Edit - removed

  // const infoWindow = hoveredMarker && (
  //   <InfoWindowContent selectedMarker={hoveredMarker} />
  // );

  const handleCountryChange = async (event) => {
    const selectedCountryId = event.target.value;
    try {
      setShowSpinner(true);
      const mapListResponse = await getMapListData(selectedCountryId);
      const positions = getPositions(mapListResponse.data);
      const listData = getRefinedListData(
        mapListResponse.data,
        mapListResponse.data.tenants.length,
      );
      setListData(listData);
      setFilteredListData(listData);
      const dropdownData = getDropdownOptions(filterData, selectedCountryId);
      setPositions(positions);
      setTenantData(dropdownData?.tenantOptions);
      setSiteData([]);
      setSelectedCountry(selectedCountryId);
      setSelectedTenant(null);
      setSelectedSite(null);
      setSelectedStatus("");
      setNoMsgText("");
    } catch (err) {
      if (err.response.data.message === "NotFound") {
        setFilteredListData([]);
        setPositions([]);
        setTenantData([]);
        setSiteData([]);
        setNoMsgText(SYSTEM_NOT_AVAILABLE);
        setSelectedCountry(selectedCountryId);
      }
    } finally {
      setShowSpinner(false);
    }
  };

  const handleTenantChange = async (event) => {
    const selectedTenantId = event.target.value;
    try {
      setShowSpinner(true);
      const mapListResponse = await getMapListData(
        selectedCountry,
        selectedTenantId,
      );
      const positions = getPositions(mapListResponse.data);
      const listData = getRefinedListData(
        mapListResponse.data,
        tenantData.length,
      );
      const siteOptions = getSitesForTenant(
        filterData,
        selectedCountry,
        selectedTenantId,
      );
      setListData(listData);
      setFilteredListData(listData);
      setPositions(positions);
      setSiteData(siteOptions);
      setSelectedTenant(selectedTenantId);
      setSelectedSite("");
      setSelectedStatus("");
      setNoMsgText("");
    } catch (err) {
      if (err.response.data.message === "NotFound") {
        setFilteredListData([]);
        setPositions([]);
        setSiteData([]);
        setNoMsgText(SYSTEM_NOT_AVAILABLE);
        setSelectedTenant(selectedTenantId);
      }
    } finally {
      setShowSpinner(false);
    }
  };

  const handleSiteChange = async (event) => {
    const selectedSiteId = event.target.value;
    setSelectedSite(selectedSiteId);
    setSelectedStatus("");
    try {
      setShowSpinner(true);
      const mapListResponse = await getMapListData(
        selectedCountry,
        selectedTenant,
        selectedSiteId,
      );
      const positions = getPositions(mapListResponse.data);
      const listData = getRefinedListData(
        mapListResponse.data,
        tenantData?.length,
      );
      setListData(listData);
      setFilteredListData(listData);
      setPositions(positions);
      setNoMsgText("");
    } catch (err) {
      if (err.response.data.message === "NotFound") {
        setFilteredListData([]);
        setPositions([]);
        setNoMsgText(SYSTEM_NOT_AVAILABLE);
        setSelectedSite(selectedSiteId);
      }
    } finally {
      setShowSpinner(false);
    }
  };

  const handleStatusChange = (event) => {
    const selectedStatus = event.target.value;
    setSelectedStatus(selectedStatus);
    const filteredListData = listData.filter((item) => {
      if (selectedStatus === ALERT_LEVEL.CRITICAL) {
        return (
          item.deviceStatus === ALERT_LEVEL.CRITICAL ||
          item.deviceStatus === ALERT_LEVEL.CRITICAL_WARNING
        );
      } else if (selectedStatus === ALERT_LEVEL.WARNING) {
        return (
          item.deviceStatus === ALERT_LEVEL.WARNING ||
          item.deviceStatus === ALERT_LEVEL.CRITICAL_WARNING
        );
      } else {
        return item.deviceStatus === selectedStatus;
      }
    });

    setFilteredListData(filteredListData);
  };

  const getMapData = async () => {
    try {
      setShowSpinner(true);
      const response = await getMapFiltersData();
      if (response && response.data) {
        const totalSitesCount = response.data.countries.flatMap((country) =>
          country.tenants.flatMap((tenant) => tenant.sites),
        ).length;
        const defaultCountry = response.data.countries.find(
          (country) => country.isDefault,
        );
        const dropdownData = getDropdownOptions(
          response.data.countries,
          defaultCountry.countryCode,
        );
        const mapListResponse = await getMapListData(
          defaultCountry.countryCode,
        );
        SettingMapSearch(mapListResponse); // Dheeraj Edit
        const positions = getPositions(mapListResponse.data);
        const listData = getRefinedListData(
          mapListResponse.data,
          dropdownData?.tenantOptions?.length,
          totalSitesCount,
        );

        if (
          dropdownData?.countryOptions?.length === 1 &&
          dropdownData?.tenantOptions?.length === 1
        ) {
          const siteOptions = getSitesForTenant(
            response.data.countries,
            defaultCountry.countryCode,
            dropdownData?.tenantOptions[0]?.value,
          );
          setSiteData(siteOptions);
        }
        setPositions(positions);
        setFilterData(response.data.countries);
        setCountriesData(dropdownData?.countryOptions);
        setTenantData(dropdownData?.tenantOptions);
        setSelectedCountry(defaultCountry.countryCode);
        setListData(listData);
        setFilteredListData(listData);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setShowSpinner(false);
    }
  };

  // Dheeraj Edit

  const handleMapSectionClick = (event) => {
    // Ensure clicks on markers (with class 'marker-container') don't close the dashboard
    if (event.target.closest(".marker-container")) {
      return; // Do nothing if the click is on a marker
    }

    // Check if the click is on the map-section or map-view
    if (
      event.currentTarget.className === "map-section" ||
      event.currentTarget.className === "map-view"
    ) {
      handleCloseDashboard();
    }
  };

  // Add this options array

  const hourOptions = [
    { value: 24, label: "Last 24hrs" },
    // { value: 72, label: "3 Days" },
    { value: 168, label: "Last Week" },
    { value: 720, label: "Last Month" },
  ];
  const getAlertLevel = (alertLevel) => {
    switch (alertLevel) {
      case ALERT_LEVEL.NORMAL_CODE:
        return ALERT_LEVEL.NORMAL.replace(/^\w/, (c) => c.toUpperCase());
      case ALERT_LEVEL.WARNING_CODE:
        return ALERT_LEVEL.WARNING.replace(/^\w/, (c) => c.toUpperCase());
      case ALERT_LEVEL.CRITICAL_CODE:
        return ALERT_LEVEL.CRITICAL.replace(/^\w/, (c) => c.toUpperCase());
      default:
        return "";
    }
  };

  const getConfigForCard = (shape) => {
    try {
      if (!shape) return null;

      // Object mapping icon names to their imported images
      const iconMap = {
        daily_usage: Daily_usage,
        data_connectivity: Data_connectivity,
        system_uptime: System_Uptime,
        reliability_score: Reliability_score,
        resources: Resources,
      };

      const iconName = shape
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]/g, "_");
      const iconSrc = iconMap[iconName] || Daily_usage; // Default to Daily_usage if no match

      return (
        <img
          src={iconSrc}
          alt={`${shape} icon`}
          style={{
            width: "20px",
            height: "20px",
            objectFit: "contain",
          }}
        />
      );
    } catch (error) {
      console.error("Error in getConfigForCard:", error, "Shape:", shape);
      return null;
    }
  };
  return (
    <div
      className="map-container"
      style={{
        flexDirection: isSmallScreen ? "column" : "row",
        height: "100%",
        width: "100%",
      }}
    >
      {/* Map Panel - Always visible */}
      <div
        className="map-section"
        onClick={(e) => {
          handleMapSectionClick(e);
        }}
        style={{
          width: "100%",
          height: isSmallScreen ? "50vh" : "100%",
          order: isSmallScreen ? 1 : 2, // This ensures it's first in mobile view
          position: "relative",
          zIndex: 1,
        }}
      >
        <div className={`map-view-${isBiggerScreen ? "med" : "sm"}`}>
          <HaqtMap
            positions={positions}
            onMarkerClick={(marker, e) => {
              handleMarkerClick(marker, e);
            }}
            selectedCenter={selectedCenter}
            // Dheeraj Edit - removed
            // onMarkerMouseOver={(marker) => {
            //   handleMarkerHover(marker);
            // }}
            // onMarkerMouseOut={(marker) => {
            //   handleMarkerLeave(marker);
            // }} // For InfoWindow hover
            // infoWindow={infoWindow}
            // selectedMarker={selectedMarker}
            // setSelectedMarker={setSelectedMarker}
          ></HaqtMap>
        </div>
      </div>

      {/* Dheeraj Edit */}
      <MapSearch searchOptions={mapSearchOptions} onSelect={SetMapCenter} />

      {/* Dashboard Panel - Only show when marker clicked */}
      {showDashboard && (
        <div
          ref={dashboardRef}
          className={"dashboard-panel-container"}
          style={{
            height: isSmallScreen ? "50vh" : "100%",
            width: isSmallScreen ? "100%" : `${dashboardWidth}px`,
            position: isSmallScreen ? "relative" : "absolute",
            left: 0,
            zIndex: 1000,
            order: isSmallScreen ? 2 : 1, // This ensure it is second in mobile
            display: "flex",
            flexDirection: "column",
            flexWrap: "wrap", // Dheeraj Edit - added
            backgroundColor: "#fff",
            border: "1px solid rgba(0, 0, 0, 0.12)",
            // borderRadius: isSmallScreen ? '12px 12px 0 0' : '8px',
            borderRadius: 0,
            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
          }}
        >
          {/* Drag handle */}

          {/* Bar Option */}
          {/* <div
            className="drag-bar"
            onMouseDown={(e) => {
              e.preventDefault();
              setDragging(true);
            }}
          /> */}

          {/* Handle Option */}
          <div
            className="drag-handle"
            onMouseDown={(e) => {
              e.preventDefault();
              setDragging(true);
            }}
          >
            <span>
              <i />
            </span>
          </div>

          <div
            className={`dashboard-panel ${isSmallScreen ? "mobile" : ""}`}
            style={{
              width: "100%",
            }}
          >
            {/* Img + Device Sno. + Rating */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                maxWidth: "100%",
                margin: "0 auto",
              }}
            >
              <img
                src={WOSH}
                alt="Wosh Dispenser"
                style={{
                  width: "100vw", // Use viewport width to ensure full screen width
                  maxWidth: "100%", // Ensure it doesn't exceed container
                  height: "300px", // Fixed height
                  objectFit: "cover", // Cover the entire area
                  objectPosition: "center", // Center the image
                  backgroundColor: "white",
                  margin: 0, // Remove margin
                  padding: 0, // Remove padding
                  display: "block", // Remove inline spacing
                  position: "relative", // Ensure proper positioning
                  left: "50%", // Center the image
                  transform: "translateX(-50%)", // Adjust for perfect centering
                  overflow: "hidden", // Hide any potential overflow
                }}
              />

              <div
                style={{
                  padding: "0 16px",
                  display: "flex",
                  flexDirection: "column", // Stack items vertically, but allow the text to break as needed
                  alignItems: "flex-start", // Left align text content for consistency
                }}
              >
                <span
                  style={{
                    fontSize: "16px", // Size for the label
                    fontWeight: "bold", // Bold label for emphasis
                    marginRight: "8px",
                    marginTop: "15px", // Space between label and star
                    marginBottom: "5px",
                  }}
                >
                  Device Name: {deviceName}{" "}
                  {/* Dheeraj Edit - Device Number -> Device Name */}
                </span>

                {dashboardData &&
                  Object.entries(dashboardData)
                    .filter(([key, card]) => card.tileName === "Reliability")
                    .map(
                      ([key, card]) =>
                        card.details &&
                        card.details.map((detail, index) => {
                          const starRating = getStarRating(detail.value);
                          return (
                            <StarRating
                              key={index}
                              rating={starRating}
                              value={detail.value}
                              // count={detail.count || 0}  // For the number in parentheses
                            />
                          );
                        }),
                    )}
              </div>
            </div>

            {/* Metrics & Insights Tabs */}
            <Box sx={{ width: "100%", typography: "body1" }}>
              <Tabs
                value={activeTab}
                onChange={handleTabChange}
                // Dheeraj Edit - sytling added
                sx={{
                  "& .MuiTabs-indicator": {
                    backgroundColor: "#0a6073", // Changes the bottom line color
                  },
                  "& .Mui-selected": {
                    color: "#0a6073 !important", // Changes the selected tab text color
                  },
                }}
              >
                <Tab label="Metrics" />
                <Tab label="Insights" />
              </Tabs>
            </Box>

            {/* Dashboard Cards */}
            {activeTab === 0 && (
              <Box className="dashboard-container">
                <div className="day-selection">
                  {hourOptions.map((option) => (
                    <button
                      key={option.value}
                      onClick={() => {
                        setSelectedHours(option.value);
                        setIsCustomClicked(false);
                      }}
                      className={`day-button ${selectedHours === option.value ? "selected" : ""}`}
                    >
                      {option.label}
                    </button>
                  ))}
                  <button
                    key={"custom"}
                    onClick={() => {
                      setShowDateRangePicker((prev) => !prev);
                      setIsCustomClicked(true);
                      setSelectedHours(1);
                    }}
                    className={`day-button ${isCustomClicked === true ? "selected" : ""}`}
                  >
                    Custom
                  </button>

                  {showDateRangePicker && (
                    <WoshDateRangePicker
                      toOpen={showDateRangePicker}
                      toClose={closeDateRangePicker}
                      handleApply={dateRangeHandler}
                    />
                  )}
                </div>
                <Grid
                  container
                  rowSpacing={{ xs: 1, sm: 2, md: 2 }}
                  columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                  columns={{ xs: 1, sm: 12, md: 12 }}
                  className="card-section"
                >
                  {Object.entries(dashboardData)
                    .filter(
                      ([key, value]) =>
                        !isNaN(key) &&
                        Number(key) <= 4 &&
                        value.tileName !== "Reliability",
                    )
                    .sort((a, b) => {
                      // Move Resources card to the end
                      // if (a[1].tileName === 'Resources') return 1;
                      //if (b[1].tileName === 'Resources') return -1;
                      // return 0;
                      // Define the order of tile names
                      const orderMap = {
                        "Daily Usage": 1,
                        "Data Sync": 2,
                        Resources: 3,
                        "System Uptime": 4,
                      };
                      // Get the order numbers for the tiles being compared
                      const orderA = orderMap[a[1].tileName] || 999; // Default high number for unknown tiles
                      const orderB = orderMap[b[1].tileName] || 999;

                      // Sort based on the order numbers
                      return orderA - orderB;
                    })
                    .map(([key, card]) => {
                      // Common function for status styles
                      const getStatusStyles = (status) => {
                        switch (status) {
                          case "Normal":
                            return {
                              backgroundColor: "#dcfce7",
                              color: "#166534",
                            };
                          case "Near Full":
                            return {
                              backgroundColor: "#fef9c3",
                              color: "#854d0e",
                            };
                          default:
                            return {
                              backgroundColor: "#fee2e2",
                              color: "#991b1b",
                            };
                        }
                      };

                      return (
                        <Grid item xs={12} key={key}>
                          <Card className="border border-gray-200 rounded-lg">
                            <CardContent className="p-6 sm:p-8">
                              <div className="card-container">
                                <div
                                  style={{
                                    width: "32px",
                                    height: "32px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderRadius: "8px",
                                  }}
                                >
                                  {getConfigForCard(card.iconShape)}
                                </div>
                                <div className="card-title">
                                  {card.tileName}
                                </div>
                              </div>

                              {/* Card Content */}
                              {card.details &&
                                card.tileName !== "Reliability" &&
                                card.details.map((detail, detailIndex) => {
                                  if (card.tileName === "Resources") {
                                    return (
                                      <div key={detailIndex}>
                                        {detail.uom === "status" ? (
                                          // Status display
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                              marginBottom: "8px",
                                            }}
                                          >
                                            <span
                                              style={{
                                                fontSize: "14px",
                                                color: "#4B5563",
                                              }}
                                            >
                                              {detail.parameterName.replace(
                                                " Level",
                                                "",
                                              )}
                                            </span>
                                            <span
                                              style={{
                                                padding: "4px 8px",
                                                borderRadius: "9999px",
                                                fontSize: "12px",
                                                fontWeight: 500,
                                                ...getStatusStyles(
                                                  detail.value,
                                                ),
                                              }}
                                            >
                                              {detail.value}
                                            </span>
                                          </div>
                                        ) : (
                                          // Progress bar display
                                          <div style={{ marginBottom: "12px" }}>
                                            <div
                                              style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                marginBottom: "8px",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  fontSize: "14px",
                                                  color: "#4B5563",
                                                }}
                                              >
                                                {detail.parameterName.replace(
                                                  " Level",
                                                  "",
                                                )}
                                              </span>
                                              <span style={{ fontWeight: 700 }}>
                                                {detail.value}%
                                              </span>
                                            </div>
                                            <div
                                              style={{
                                                width: "100%",
                                                backgroundColor: "#e5e7eb",
                                                borderRadius: "9999px",
                                                height: "8px",
                                                overflow: "hidden",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  width: `${detail.value}%`,
                                                  backgroundColor: "#2563eb",
                                                  height: "100%",
                                                  borderRadius: "9999px",
                                                  transition: "width 0.5s ease",
                                                }}
                                              />
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    );
                                  } else {
                                    let titleClass = "card-detail-title";

                                    if (detail.uom === "%") {
                                      const value = parseFloat(detail.value);
                                      if (value > 80) {
                                        titleClass +=
                                          " card-detail-title-green";
                                      } else if (value < 40) {
                                        titleClass += " card-detail-title-red";
                                      } else {
                                        titleClass +=
                                          " card-detail-title-yellow";
                                      }
                                    }

                                    return (
                                      <div
                                        key={detailIndex}
                                        className="card-detail"
                                      >
                                        <div
                                          className={`card-detail-title ${titleClass}`}
                                        >
                                          {detail.value}
                                          {detail.uom === "%" ? "%" : ""}
                                        </div>
                                        <div className="card-detail-desc">
                                          {card.tileDesc}
                                        </div>
                                      </div>
                                    );
                                  }
                                })}
                            </CardContent>
                          </Card>
                        </Grid>
                      );
                    })}
                </Grid>
              </Box>
            )}

            {/* Dashboard Charts */}
            {activeTab === 1 && (
              <Box className="dashboard-container">
                <div className="day-selection">
                  {hourOptions.map((option) => (
                    <button
                      key={option.value}
                      onClick={() => {
                        setSelectedHours(option.value);
                        setIsCustomClicked(false);
                      }}
                      className={`day-button ${selectedHours === option.value ? "selected" : ""}`}
                    >
                      {option.label}
                    </button>
                  ))}
                  <button
                    key={"custom"}
                    onClick={() => {
                      setShowDateRangePicker((prev) => !prev);
                      setIsCustomClicked(true);
                      setSelectedHours(null);
                    }}
                    className={`day-button ${isCustomClicked === true ? "selected" : ""}`}
                  >
                    Custom
                  </button>

                  {showDateRangePicker && (
                    <WoshDateRangePicker
                      toOpen={showDateRangePicker}
                      toClose={closeDateRangePicker}
                      handleApply={dateRangeHandler}
                    />
                  )}
                </div>

                <Grid container spacing={2}>
                  {dashboardData.charts &&
                    dashboardData.charts.map((tile, tileIndex) => {
                      const getSeries = () => {
                        // If details is null or empty, return appropriate default data
                        if (!tile.details) {
                          switch (tile.chartType) {
                            case "line":
                              return [
                                {
                                  type: "line",
                                  name: tile.tileName,
                                  data: [],
                                },
                              ];
                            case "column":
                              return [
                                {
                                  type: "column",
                                  name: "Error codes",
                                  data: [
                                    {
                                      name: "No Errors",
                                      y: 0,
                                      color: "#E0E0E0",
                                    },
                                  ],
                                },
                              ];
                            case "donut":
                              return [
                                {
                                  type: "pie",
                                  innerSize: "90%",
                                  data: [
                                    {
                                      name: "No Data",
                                      y: 100,
                                      color: "#E0E0E0",
                                    },
                                  ],
                                },
                              ];
                            default:
                              return [];
                          }
                        }

                        const isAllZeros = tile.details.every(
                          (item) => parseFloat(item.value) === 0,
                        );

                        switch (tile.chartType) {
                          case "line":
                            return [
                              {
                                type: "line",
                                name: "Hand wash count(Hrs)",
                                data: tile.details.map((item) => [
                                  item.desc,
                                  parseFloat(item.value),
                                ]),
                              },
                            ];

                          case "column":
                            if (!tile.details) {
                              return [
                                {
                                  type: "column",
                                  name: "Error codes",
                                  data: [
                                    {
                                      name: "No Errors",
                                      y: 0,
                                      color: "#E0E0E0",
                                    },
                                  ],
                                },
                              ];
                            }
                            // Create categories and data arrays separately
                            var categories = [];
                            var values = [];
                            var colors = [];

                            // Iterate through tile.details and check if the value is valid
                            for (var i = 0; i < tile.details.length; i++) {
                              // Ensure 'desc' exists and is a valid string
                              categories.push(
                                tile.details[i].desc || "Unknown",
                              );

                              // Ensure 'value' is a valid number, and fallback to 0 if it's invalid
                              var value = parseFloat(tile.details[i].value);

                              if (isNaN(value)) {
                                value = 0; // Fallback to 0 if the value is not a valid number
                              }

                              values.push(value);
                              colors.push("#36C8B4");
                            }

                            // Create data points with just y values
                            var barData = values.map(function (value, index) {
                              return {
                                y: value,
                                color: colors[index], // Use the correct color per data point
                              };
                            });

                            return [
                              {
                                name: "Error codes",
                                type: "column",
                                data: barData,
                                categories: categories, // Add categories separately
                              },
                            ];

                          case "donut":
                            if (isAllZeros) {
                              return [
                                {
                                  type: "pie",
                                  innerSize: "80%",
                                  data: [
                                    {
                                      name: "No Cost Data",
                                      y: 100,
                                      color: "#E0E0E0",
                                    },
                                  ],
                                },
                              ];
                            }
                            return [
                              {
                                type: "pie",
                                innerSize: "80%",
                                data: tile.details.map((item, index) => ({
                                  name: item.desc,
                                  y: parseFloat(item.value),
                                  color: ["#36C8B4", "#148595"][index % 2],
                                })),
                              },
                            ];

                          default:
                            return [];
                        }
                      };

                      const getChartOptions = () => {
                        const baseOptions = {
                          chart: {
                            height: 400,
                            zoomType: "x",
                          },
                          title: {
                            align: "center",
                          },
                          subtitle: {
                            align: "center",
                            y: 35,
                          },
                          xAxis: { type: "datetime" },
                          yAxis: {
                            title: "Values",
                          },
                          legend: {
                            align: "center",
                            verticalAlign: "top",
                          },
                          tooltip: {
                            borderColor: "#fff",
                            borderRadius: 0,
                            borderWidth: 1,
                            className: "dashboard-chart-tooltip",
                          },
                          exporting: {
                            isChartType: false,
                            enabled: true,
                            fileName: "ChartsTest Insights",
                          },
                          plotOptions: {
                            series: {
                              dataLabels: {
                                enabled: true,
                              },
                            },
                          },
                        };

                        switch (tile.chartType) {
                          case "line":
                            return {
                              ...baseOptions,
                              xAxis: {
                                type: "category",
                                tickInterval: 12,
                                labels: {
                                  enabled: true,
                                  rotation: -45,
                                  style: { fontSize: "10px" },
                                  overflow: "justify",
                                  align: "right",
                                  formatter: function () {
                                    if (!this.value) return "";
                                    return this.value.split(" ").pop();
                                  },
                                },
                                tickmarkPlacement: "on",
                                gridLineWidth: 1,
                              },
                              title: {
                                text: tile.tileName,
                                align: "center",
                                marginBottom: 100,
                              },
                              plotOptions: {
                                line: {
                                  marker: { enabled: true },
                                  dataLabels: { enabled: true },
                                },
                              },
                            };

                          case "column":
                            return {
                              ...baseOptions,
                              chart: {
                                type: "column",
                                marginBottom: 100,
                                marginLeft: 80,
                                marginRight: 40,
                              },
                              title: {
                                text: tile.tileName,
                                align: "center",
                                marginBottom: 100,
                              },
                              xAxis: {
                                categories: tile.details
                                  ? tile.details.map((item) => item.desc)
                                  : ["No Errors"],
                                title: {
                                  text: "Error Codes",
                                  style: {
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                    color: "#333333",
                                  },
                                },
                                labels: {
                                  enabled: true,
                                  style: { fontSize: "11px" },
                                  rotation: 0,
                                },
                              },

                              plotOptions: {
                                column: {
                                  borderRadius: 5,
                                  columnWidth: "60%",
                                  showInLegend: true,
                                  dataLabels: {
                                    enabled: true,
                                    style: {
                                      fontWeight: "bold",
                                      color: "#000",
                                    },
                                  },
                                },
                              },
                              series: [
                                {
                                  name: "Error codes",
                                  data: tile.details
                                    ? tile.details.map((item) => ({
                                        name: item.desc,
                                        y: parseFloat(item.value || 0) || 0,
                                        color: "#36C8B4",
                                      }))
                                    : [
                                        {
                                          name: "No Errors",
                                          y: 0,
                                          color: "#E0E0E0",
                                        },
                                      ],
                                },
                              ],
                            };

                          case "donut":
                            return {
                              ...baseOptions,
                              chart: {
                                type: "pie",
                                marginBottom: 60,
                              },
                              title: {
                                text: tile.tileName,
                                align: "center",
                                marginBottom: 100,
                              },
                              plotOptions: {
                                pie: {
                                  allowPointSelect: true,
                                  cursor: "pointer",
                                  dataLabels: {
                                    enabled: true,
                                    format:
                                      "<b>{point.name}</b>: {point.y:.2f} ({point.percentage:.1f}%)",
                                    distance: 20,
                                  },
                                  showInLegend: true,
                                  innerSize: "50%",
                                  size: "75%",
                                },
                              },
                            };

                          default:
                            return baseOptions;
                        }
                      };

                      return (
                        <Grid
                          item
                          xs={12}
                          key={`${tile.tileName}-${tileIndex}`}
                        >
                          <Card
                            className="border border-gray-300 rounded-lg"
                            sx={{
                              width: "99%",
                              height: { xs: "450px", sm: "450px" },
                            }}
                          >
                            <CardContent
                              sx={{
                                height: "100%",
                                p: "16px !important",
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              {(tile.chartType === "column" &&
                                (!tile.details ||
                                  tile.details.every(
                                    (item) => parseFloat(item.value) === 0,
                                  ))) ||
                              (tile.chartType === "donut" &&
                                (!tile.details ||
                                  tile.details.every(
                                    (item) => parseFloat(item.value) === 0,
                                  ))) ? (
                                <NoDataDisplay />
                              ) : (
                                <Box
                                  sx={{
                                    flex: 1, // This will make it take remaining space
                                    minHeight: 0, // Important for flex child
                                  }}
                                >
                                  <HaqtChart
                                    key={`chart-${selectedHours}`}
                                    options={getChartOptions()}
                                    series={getSeries()}
                                  />
                                </Box>
                              )}
                            </CardContent>
                          </Card>
                        </Grid>
                      );
                    })}
                </Grid>
              </Box>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default MapView;
